import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { TOUR_STEP_IDS } from '@/fsd/entities/onboarding/model/consts/tourStepIds';
import { Step } from 'react-joyride';

export const isPrimaryButtonEnabled = (step: Step): boolean => {
  if (step.id !== TOUR_STEP_IDS.WAIT_FOR_INITIAL_REMAINS) {
    return true;
  }

  const queries = queryClient.getQueryCache().findAll({ queryKey: ['acceptancesList'] });
  
  return queries.some((query) => {
    const data = query.state.data as any;
    return data && data.data && data.data.length > 0;
  });
};
